import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { cardImage, digitalServices } from '../../data/home';
export function DigitalBanking() {
  return <section className="w-full bg-white py-24" data-id="element-56" data-mp="1hoj0f91225gy">
      <div className="mx-auto grid max-w-[1320px] items-center gap-14 px-6 lg:grid-cols-12" data-id="element-57" data-mp="1hqdmwrrz65n5">
        <div className="relative lg:col-span-5" data-id="element-58" data-mp="1cw9fy8iplxm2">
          <div className="flex aspect-square items-center justify-center overflow-hidden rounded-[32px] bg-canvas" data-id="element-59" data-mp="1qofslkmnlmgr">
            <img src={cardImage} alt="Carte bancaire GIMTEL de Chinguitty Bank" className="w-[82%] mix-blend-multiply" data-id="element-60" data-mp="1loukokpia3rw" />
          </div>
          <div className="absolute bottom-6 left-6 rounded-2xl bg-ink px-5 py-4 text-white" data-id="element-61" data-mp="1vnshsc0zz5mi">
            <p className="text-[12px] text-white/50" data-id="element-62" data-mp="68c7uuf91fvk">Disponible</p>
            <p className="font-display text-[34px] text-leaf" data-id="element-63" data-mp="6aynzig7h3pe">24h/24</p>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-64" data-mp="20v9b5ljh9s7c">
          <h2 className="font-display text-[52px] text-ink md:text-[72px]" data-id="element-65" data-mp="20wanrug56mr6">
            Votre banque,
            <br data-id="element-66" data-mp="24xw6vxj9rx9t" />
            dans votre poche
          </h2>
          <p className="mt-5 max-w-lg text-[16px] leading-relaxed text-ink-muted" data-id="element-67" data-mp="29vxmu9lefgh2">
            Suivez vos comptes, recevez vos alertes et payez en toute sécurité, sans passer en agence.
          </p>

          <ul className="mt-10 border-t border-line" data-id="element-68" data-mp="2jm0spadmcowt">
            {digitalServices.map(s => <li key={s.name} className="border-b border-line" data-id="element-69" data-mp="2oklhmdnf7m5y">
                <Link to={s.path} className="group flex items-start gap-6 py-6" data-id="element-70" data-mp="2oj0peuokwfb9">
                  <div className="flex-1" data-id="element-71" data-mp="2smymkzucfg1o">
                    <p className="text-[22px] font-semibold text-ink transition-colors group-hover:text-brand" data-id="element-72" data-mp="2xljm0x1rtvp2">
                      {s.name}
                    </p>
                    <p className="mt-1.5 max-w-lg text-[15px] leading-relaxed text-ink-muted" data-id="element-73" data-mp="ya8soi3z66ua">{s.text}</p>
                  </div>
                  <ArrowUpRightIcon className="mt-1.5 h-5 w-5 shrink-0 text-ink/40 transition-[color,transform] duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-brand" aria-hidden="true" data-id="element-74" data-mp="26iep8qq8gsvi" />
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}